import {Form, Tabs} from 'antd';
import {FormInstance} from 'antd/es/form/Form';
import React, {FC} from 'react';

import { useLookupCheck } from '../hooks';
import {
    EFFECT_INFLUENCE_LOOKUP_URL,
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS,
    FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES,
    IS_NOT_AFFECT_LOOKUP_CODE,
} from '../model/constants';
import {IMacroEconomicItemForm} from '../model/types';
import {AdditionalFieldsTab} from './components/additional-fields-tab';
import {FactorsListTab} from './components/factors-list-tab';
import {MainInfoTab} from './components/main-info-tab';
import s from './factor-influence-info-item-modal-form.module.less';

const {TabPane} = Tabs;

interface IFactorInfluenceInfoItemModalFormProps {
    form: FormInstance<any>;
    handleFinish: () => void;
    activeTab: string;
    setActiveTab: (tab: string) => void;
    effectInfluence: number | undefined;
    setEffectInfluence: (value: number | undefined) => void;
    isReadOnly?: boolean;
}

export const FactorInfluenceInfoItemModalForm: FC<IFactorInfluenceInfoItemModalFormProps> = ({
    form,
    activeTab,
    setActiveTab,
    effectInfluence,
    setEffectInfluence,
    handleFinish,
    isReadOnly = false,
}: IFactorInfluenceInfoItemModalFormProps) => {
    const isNotAffect = useLookupCheck(EFFECT_INFLUENCE_LOOKUP_URL, IS_NOT_AFFECT_LOOKUP_CODE);
    const isAdditionalFieldsTabDisabled = isNotAffect(effectInfluence) || !effectInfluence;

    const handleValuesChange = (changedValues: Partial<IMacroEconomicItemForm>) => {
        if ('effectInfluenceId' in changedValues) {
            setEffectInfluence(changedValues.effectInfluenceId || undefined);
        }
    };

    return (
        <Form<IMacroEconomicItemForm>
            className={s['factor-influence-info-item-modal-form']}
            form={form}
            layout="vertical"
            onFinish={handleFinish}
            onValuesChange={handleValuesChange}
        >
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane
                    tab={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.MAIN}
                    key={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS.MAIN}
                    forceRender
                >
                    <MainInfoTab isReadOnly={isReadOnly} />
                </TabPane>
                <TabPane
                    tab={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.ADDITIONAL}
                    key={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS.ADDITIONAL}
                    disabled={isAdditionalFieldsTabDisabled} forceRender
                >
                    {!isAdditionalFieldsTabDisabled && <AdditionalFieldsTab isReadOnly={isReadOnly} />}
                </TabPane>
                <TabPane
                    tab={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_NAMES.FACTORS}
                    key={FACTOR_INFLUENCE_INFO_ITEM_MODAL_TAB_KEYS.FACTORS}
                    disabled={isAdditionalFieldsTabDisabled}
                    forceRender
                >
                    {!isAdditionalFieldsTabDisabled && <FactorsListTab isReadOnly={isReadOnly} />}
                </TabPane>
        </Tabs>
    </Form>
    );
};

